module.exports = __webpack_public_path__ + "static/img/mybg.855af4a6.png";